import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// provided services
import { AuthService } from './auth.service';
import { AuthenticatedUserService, NotAuthenticatedService } from './auth-guard.service';
import { LoginComponent } from '../login/login.component';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  declarations: [LoginComponent],
  providers: [AuthService, AuthenticatedUserService, NotAuthenticatedService],
  imports: [CommonModule, AuthRoutingModule]
})
export class AuthModule {}
